import React from 'react';
import { FaCalculator, FaChessKnight, FaUserTie } from 'react-icons/fa';

export const ValueProps = () => {
    return (
        <section className="value-props-section">
            <div className="container">
                <div className="text-center" style={{ marginBottom: '3rem' }}>
                    <h2>Soluciones que Impulsan su Negocio</h2>
                    <p style={{ maxWidth: '600px', margin: '0 auto' }}>Nos enfocamos en tres pilares fundamentales para garantizar el crecimiento sostenido de su empresa.</p>
                </div>

                <div className="value-grid">
                    <div className="value-card">
                        <FaCalculator className="value-icon" />
                        <h3 className="value-title">Precisión Técnica</h3>
                        <p>Garantizamos el cumplimiento exacto de todas las normativas vigentes, minimizando riesgos fiscales y errores administrativos. Su tranquilidad es nuestra prioridad.</p>
                    </div>

                    <div className="value-card">
                        <FaChessKnight className="value-icon" />
                        <h3 className="value-title">Visión Estratégica</h3>
                        <p>No solo liquidamos impuestos; analizamos sus números para ofrecerle herramientas de toma de decisiones que potencien la rentabilidad de su negocio.</p>
                    </div>

                    <div className="value-card">
                        <FaUserTie className="value-icon" />
                        <h3 className="value-title">Atención Personalizada</h3>
                        <p>Un equipo de profesionales dedicados a entender la realidad de su empresa. Comunicación directa, sin intermediarios ni demoras.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};
